module.exports = __webpack_public_path__ + "static/media/rayen.c91bd519.png";